import { useCallback, useEffect, useState } from 'react'
import { useWbsItemRepository } from '../../../../services/adaptors/wbsItemRepositoryAdaptor'
import {
  Attachment,
  AttachmentCandidate,
} from '../../../../domain/value-object/Attachment'
import { WbsItemTypeVO } from '../../../../domain/value-object/WbsItemTypeVO'

export const useAttachmentHandlers = (
  uuid: string,
  projectUuid: string,
  type: WbsItemTypeVO,
  initialDeliverableAttachments?: Attachment[]
) => {
  const [deliverableAttachments, setDeliverableAttachments] = useState<
    Attachment[]
  >([])
  useEffect(() => {
    setDeliverableAttachments(initialDeliverableAttachments || [])
  }, [initialDeliverableAttachments])

  const {
    addAttachments: _addAttachments,
    deleteAttachments: _deleteAttachments,
  } = useWbsItemRepository()
  const addAttachments = useCallback(
    async (attachments: AttachmentCandidate[]) => {
      await _addAttachments(projectUuid, {
        wbsItemUuid: uuid,
        type,
        attachmentType: 'DELIVERABLE',
        attachments,
      })
      setDeliverableAttachments(prev => {
        return [...prev, ...attachments]
      })
    },
    [_addAttachments, uuid, projectUuid, type]
  )
  const deleteAttachments = useCallback(
    async (attachments: Attachment[]) => {
      await _deleteAttachments(projectUuid, {
        wbsItemUuid: uuid,
        type,
        attachmentType: 'DELIVERABLE',
        attachmentItemUuids: attachments.map(attachment => attachment.uuid),
      })
      setDeliverableAttachments(prev => {
        return prev.filter(v =>
          attachments.some(deleted => v.uuid !== deleted.uuid)
        )
      })
    },
    [_deleteAttachments, uuid, projectUuid, type]
  )
  return {
    deliverableAttachments,
    addAttachments,
    deleteAttachments,
  }
}
